/* eslint-disable no-magic-numbers */

import Nothing from './phase-core/Nothing';
import Start from './phase-core/Start';
import Stop from './phase-core/Stop';

import TyrFeedback from './phase-audio/TyrFeedback';
import LowHum from './phase-audio/LowHum';
import KickRhythm from './phase-audio/KickRhythm';

import RhythmFactory from './audio/RhythmFactory';

const rhythms = new RhythmFactory();

/* Define the timeline of changes to state of audio generator objects */

export default [

	/* Brainwaves */

	[new Nothing(6)],

	[new Start('feedback')],

	[new TyrFeedback(18)],

	[new Start('kick', 0.1)],

	[new LowHum()],

	[new KickRhythm(16, rhythms.createMetronome(8, { harmonics0: 4 }))],

	/* Triangle */

	[new KickRhythm(12, rhythms.createMetronome(2, { div: 2, harmonics0: 8, velocity: 0.3 }))],
	[new KickRhythm(2, rhythms.createMetronome(1, { div: 2, harmonics0: 8 }))],
	[new KickRhythm(2, rhythms.createMetronome(1, { div: 4, harmonics0: 8 }))],

	[new KickRhythm(12, rhythms.createMetronome(4, { div: 4, harmonics: 4, velocity: 0.2, fundamental: 100 }))],
	[new KickRhythm(2, rhythms.createMetronome(2, { div: 4, harmonics: 4, velocity: 0.2, fundamental: 100 }))],
	[new KickRhythm(2, rhythms.createMetronome(1, { div: 4, harmonics: 4, velocity: 0.2, fundamental: 100 }))],

	/* Head+pusher */

	[
		new KickRhythm(15, rhythms.createMetronome(4, { div: 4, harmonics: 4, velocity: 0.6, harmonics0: 4, velocity0: 2, fundamental: 34 })),
	],
	[new Nothing(1)],

	/* Head turning */

	/* End */

	[
		new Stop('kick'),
		new Stop('feedback'),
	],
	[new Nothing(8)],

];
